<script lang="ts">
  import IconsChevronDown from '$lib/components/icons/IconsChevronDown.svelte';
  import IconsChevronUp from '$lib/components/icons/IconsChevronUp.svelte';
  import Tooltip from '$lib/components/Tooltip.svelte';
  import type { QueueAggregations } from '$lib/server/db/types';
  import { slide } from 'svelte/transition';

  export let playersInQueue: QueueAggregations;
  let expanded = false;
</script>

<div
  class="bg-grays-dark fixed bottom-4 left-1/2 -translate-x-1/4 transform rounded-lg px-4 py-2 text-sm text-gray-300 shadow-lg shadow-black drop-shadow-lg"
>
  <div class="flex w-full items-center justify-between">
    <span class="w-5"></span>
    <button on:click={() => (expanded = !expanded)} class="flex w-16 flex-col items-center">
      {#if !expanded}
        <IconsChevronUp class="h-5 w-5" />
      {:else}
        <IconsChevronDown class="h-5 w-5" />
      {/if}
    </button>
    <Tooltip>
      Players that queued up in the last 10 minutes and are not currently in game or in a lobby. It is possible that
      players left queue, but did not join a game, and are still counted as in queue.
    </Tooltip>
  </div>
  <div>
    <p><span class="font-mono">{playersInQueue.num_ranked}</span> players in 1v1 ranked queue</p>
    {#if expanded}
      <div transition:slide={{ duration: 500 }}>
        <div class="flex justify-between">
          <p>&lt;1000 Elo</p>
          <p class="font-mono">{playersInQueue.ranked.elo_less_1000}</p>
        </div>
        <div class="flex justify-between">
          <p>1000-1600 Elo</p>
          <p class="font-mono">{playersInQueue.ranked.elo_1000_1600}</p>
        </div>
        <div class="flex justify-between">
          <p>1600+ Elo</p>
          <p class="font-mono">{playersInQueue.ranked.elo_1600_plus}</p>
        </div>
        <br />
        <div class="flex justify-between">
          <p>Ranked teams</p>
          <p class="font-mono">{playersInQueue.num_teamqueue}</p>
        </div>
        <div class="flex justify-between">
          <p>Quickmatch</p>
          <p class="font-mono">{playersInQueue.num_quickmatch}</p>
        </div>
      </div>
    {/if}
  </div>
</div>
